<template>
    <ul class="teams-wrapper">
        <li v-for="(item, index) in teams" :key="index">
            <div class="avatar">
                <i v-if="item.number_type == 1">团长</i>
                <img
                    :src="`https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/avatar-${
                        index + 1
                    }.png`"
                />
            </div>
            <h2>
                {{ item.rolename
                }}<span v-if="user.rolename == item.rolename">我</span>
            </h2>
        </li>
        <li v-for="(item, index) in 5 - teams.length" :key="index">
            <div class="add" @click="addEvent"></div>
        </li>
    </ul>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, inject } from "vue";
import useStore from "@/store/store.js";
const { user, teams } = storeToRefs(useStore());
const loginRef = inject("loginRef");
const bindRef = inject("bindRef");

const { inviteFn } = defineProps({
    inviteFn: { type: Function }
});

// 加入队伍
const addEvent = () => {
    if (!user.value.islogin) {
        return loginRef.value.Show();
    }
    if (!user.value.rolename) {
        return bindRef.value.Show();
    }
    if (!user.value.cur_team_id) {
        return CsGame.alert("请先创建或加入兄弟团！", 1200, "error");
    }
    inviteFn();
};
</script>

<style lang="scss" scoped>
.teams-wrapper {
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: center;
    left: 0px;
    bottom: 40px;
    li {
        text-align: center;
        .avatar {
            width: 132px;
            height: 132px;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/role-bg.png");
            background-position: -193px 0px;
            margin: 0px 25px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            i {
                position: absolute;
                width: 24px;
                height: 58px;
                display: flex;
                justify-content: center;
                align-items: center;
                right: 6px;
                top: 0px;
                font-style: normal;
                background-color: #792520;
                color: #f0b45c;
                border: 1px solid #f0b45c;
            }
            img {
                width: 124px;
                border-radius: 50%;
            }
        }
        h2 {
            margin-top: 12px;
            color: #f0b45c;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
                display: block;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                background: #812325;
                color: #ffdba7;
                font-size: 14px;
                text-align: center;
                line-height: 22px;
                margin-left: 6px;
                border: 1px solid #ffdba7;
            }
        }
        .add {
            cursor: pointer;
            width: 132px;
            height: 132px;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/role-bg.png");
            margin: 0px 25px;
            background-position: 0px 0px;
        }
    }
}
</style>
